const isMac = () => navigator.userAgent.includes("Macintosh");
const isWindows = () => navigator.userAgent.includes("Windows");
const isLinux = () => navigator.userAgent.includes("Linux");
const isAndroid = () => navigator.userAgent.includes("Android");
const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent);

export { isMac, isWindows, isLinux, isAndroid, isIOS };
